/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import FirestoreTimestampToDate from "../helpers/timestampDate";
import { FiSearch, FiFilter } from "react-icons/fi";
import { IoCardOutline } from "react-icons/io5";

const Transaction = () => {
  const [id, setId] = useState(localStorage.getItem("roomId") || "");
  const [transactions, setTransactions] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("hash");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  useEffect(() => {
    const fetchTransactions = async () => {
      const transactionsCollection = db.collection("rooms").doc(id).collection("transactions");
      const snapshot = await transactionsCollection.get();
      const transactionsData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        timestamp: FirestoreTimestampToDate(doc.data().timestamp),
        id: doc.id,
      }));
      setTransactions(transactionsData);
      setAllTransactions(transactionsData);
    };

    fetchTransactions();
  }, [id]);

  useEffect(() => {
    if (!searchTerm) {
      setTransactions(allTransactions);
      return;
    }
    const filteredTransactions = allTransactions.filter((transaction) => {
      if (filter === "hash") {
        return transaction.id.includes(searchTerm);
      } else if (filter === "sender") {
        return transaction.sender.includes(searchTerm);
      } else if (filter === "receiver") {
        return transaction.receiver.includes(searchTerm);
      } else if (filter === "status") {
        return transaction.status.includes(searchTerm);
      } else if (filter === "timestamp") {
        return transaction.timestamp.includes(searchTerm);
      } else if (filter === "amount") {
        return transaction.amount.toString().includes(searchTerm);
      }
      return false;
    });
    setTransactions(filteredTransactions);
  }, [searchTerm, filter, allTransactions]);

  const renderTrimmedAddress = (address) => `${address.substring(0, 10)}...`;

  return (
    <div className="max-w-[1600px]">
      {/* Header */}
      <div className="glass-card p-6 mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center gap-3">
          <IoCardOutline className="text-primary" />
          Transactions
          <span className="text-text-muted font-normal text-lg">for {id}</span>
        </h2>
      </div>

      {/* Search & Filter */}
      <div className="glass-card p-4 mb-6">
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <div className="relative flex-1 w-full">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted" />
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search transactions..."
              className="w-full bg-white/5 border border-white/10 rounded-lg pl-10 pr-4 py-3 text-white placeholder-text-muted focus:outline-none focus:border-primary transition-colors"
            />
          </div>
          <div className="relative w-full sm:w-auto">
            <FiFilter className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted" />
            <select
              value={filter}
              onChange={handleFilterChange}
              className="w-full sm:w-48 bg-white/5 border border-white/10 rounded-lg pl-10 pr-4 py-3 text-white appearance-none focus:outline-none focus:border-primary transition-colors cursor-pointer"
            >
              <option value="hash" className="bg-surface">
                Transaction ID
              </option>
              <option value="sender" className="bg-surface">
                Sender
              </option>
              <option value="receiver" className="bg-surface">
                Receiver
              </option>
              <option value="status" className="bg-surface">
                Status
              </option>
              <option value="timestamp" className="bg-surface">
                Timestamp
              </option>
              <option value="amount" className="bg-surface">
                Amount
              </option>
            </select>
          </div>
        </div>
      </div>

      {/* Transactions Table */}
      <div className="glass-card p-6 overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-white/10">
              <th className="py-4 px-4 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                Transaction ID
              </th>
              <th className="py-4 px-4 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                Sender
              </th>
              <th className="py-4 px-4 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                Receiver
              </th>
              <th className="py-4 px-4 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                Status
              </th>
              <th className="py-4 px-4 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                Timestamp
              </th>
              <th className="py-4 px-4 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => (
              <tr
                key={index}
                className="border-b border-white/5 hover:bg-white/5 transition-colors"
              >
                <td className="py-4 px-4">
                  <code className="text-white bg-white/10 px-2 py-1 rounded text-sm">
                    {transaction.id}
                  </code>
                </td>
                <td className="py-4 px-4">
                  <code className="text-green-400 text-sm" title={transaction.sender}>
                    {renderTrimmedAddress(transaction.sender)}
                  </code>
                </td>
                <td className="py-4 px-4">
                  <code className="text-blue-400 text-sm" title={transaction.receiver}>
                    {renderTrimmedAddress(transaction.receiver)}
                  </code>
                </td>
                <td className="py-4 px-4">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      transaction.status === "completed" || transaction.status === "Added to chain"
                        ? "bg-green-500/20 text-green-400"
                        : transaction.status === "pending" || transaction.status === "Verify"
                          ? "bg-yellow-500/20 text-yellow-400"
                          : "bg-blue-500/20 text-blue-400"
                    }`}
                  >
                    {transaction.status}
                  </span>
                </td>
                <td className="py-4 px-4 text-text-muted text-sm">{transaction.timestamp}</td>
                <td className="py-4 px-4 text-white font-medium">{transaction.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {transactions.length === 0 && (
          <div className="text-center py-12 text-text-muted">No transactions found</div>
        )}
      </div>
    </div>
  );
};

export default Transaction;
